import { render, staticRenderFns } from "./UserSettingMobileChange.vue?vue&type=template&id=0831ff2c&"
import script from "./UserSettingMobileChange.vue?vue&type=script&lang=js&"
export * from "./UserSettingMobileChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports